import { render, staticRenderFns } from "./TreatmentDirectoryRecommendation.vue?vue&type=template&id=4092ea17&scoped=true"
import script from "./TreatmentDirectoryRecommendation.vue?vue&type=script&lang=js"
export * from "./TreatmentDirectoryRecommendation.vue?vue&type=script&lang=js"
import style0 from "./TreatmentDirectoryRecommendation.vue?vue&type=style&index=0&id=4092ea17&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4092ea17",
  null
  
)

export default component.exports